import { Icon24Warning } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const WarningTriangleIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      <path
        id="Vector"
        d="M13.8515 3.77063L22.0509 18.0084C22.6256 19.0116 21.8831 20.25 20.7 20.25H4.30121C3.11808 20.25 2.37558 19.0116 2.95027 18.0084L11.1496 3.77063C11.7403 2.74313 13.2609 2.74313 13.8515 3.77063Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M12.5 13.5V9.75"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M12.5 17.8125C13.0178 17.8125 13.4375 17.3928 13.4375 16.875C13.4375 16.3572 13.0178 15.9375 12.5 15.9375C11.9822 15.9375 11.5625 16.3572 11.5625 16.875C11.5625 17.3928 11.9822 17.8125 12.5 17.8125Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const WarningTriangleIcon = fplIcon(WarningTriangleIconLocal, Icon24Warning);
